<template>
  <div class="container">
    <h1>Aceptar Términos y Condiciones</h1>
    <div class="terms">
      

      <h2>Políticas de Servicio</h2>
      <ul>
        <li>Reservaciones deberán llegar 15 minutos antes. Puntualidad, mesa se retiene por 15 minutos. Podrá perder reservación y deberá esperar una mesa según disponibilidad. Se le atenderá.</li>
        <li>La persona que hace la reservación, es quién deberá presentarse en el Host con TODAS las personas a la hora que le corresponde. Si el grupo no está completo deberán esperar por todos para poder sentarse. Máximo de 3 tickets por reservación.</li>
        <li>Se prohíbe la entrada con alcohol. Todo vaso insulado deberá de estar vacío para entrar al restaurante (todas las veces que entre y salga). De lo contrario se le cobrará $5.00 por cuota de servicio. De traer algún vino de su predilección se le cobrará el descorche a $20.00</li>
        <li>De traer bizcocho se cobrará un fee de $30.00 y deberán traer platos y cucharas (no damos vela).</li>
        <li>Toda RSVP realizada de 2 a 3 semanas de anticipación tendrá el privilegio de seleccionar si desean la mesa al aire libre (deberá notificarlo al reservar). Dependerá de disponibilidad, cantidad de personas, tiempo atmosférico y clima. No informamos de actividades y/o reservaciones que alquilan áreas en el restaurante. Siempre que haya una mesa para que disfrute de la experiencia se le confirmará la RVSP.</li>
        <li>Cambios a la RSVP deberán hacerse con una semana de anticipación. Todo aumento o disminución de personas puede cambiar la selección de área o mesa. Reservaciones hechas tardías (mismo día a 7 días antes del día a reservar los ubicaremos a disponibilidad de mesa.</li>
        <li>Favor contar niños, ellos también son parte de la RSVP.</li>
        <li>Tendrá un máximo de 2 horas y 1/2 en la mesa. Si se excede tendrán que pagar un cargo ($150 por hora o fracción de tiempo) y va a depender si la mesa está disponible para poder ofrecerle tiempo adicional. Las 2 horas y 1/2 comienzan desde la hora de la RSVP.</li>
        <li>De haber atrasos por tiempo en restaurante las 2 horas y 1/2 comenzarán a partir de que se le asigne la mesa.</li>
        <li>Grupos de 25 personas en adelante se trabajan por cotizaciones (cenas, cumpleaños, bodas, baby gender, etc). Para información enviar mensaje de texto al 787-900-4682 con su nombre, día, hora, cantidad de personas, motivo de la actividad y un correo electrónico. Se le llamará para orientación y coordinación.</li>
        <li>Somos Petfriendly, por lo que deberá indicar si llevará a su mascota.</li>
        <li>Podrá encontrar nuestro menú en asadorsanmiguelpr.com.</li>
        <li>Toda persona que llegue sin RSVP podrá ser atendida de haber espacios disponibles. De lo contrario deberá anotarse en lista de espera hasta que surja un espacio. No se aceptarán walk-ins en temporadas altas y días que estemos a capacidad.</li>
        <li>Toda reclamación deberá hacerse antes de salir de las facilidades.</li>
        <li><strong>NOS RESERVAMOS EL DERECHO DE ADMISIÓN.</strong></li>
      </ul>
    </div>

    <form @submit.prevent="acceptTerms">
      <div>
        <input type="checkbox" v-model="accepted" id="accepted" required>
        <label for="accepted">Acepto los términos y condiciones</label>
      </div>
      <button type="submit" :disabled="!accepted">Aceptar</button>
    </form>
  </div>
</template>

<script>
import { ref } from 'vue';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase/init';

export default {
  name: 'AcceptTerms',
  setup() {
    const accepted = ref(false);
    const reservationId = new URLSearchParams(window.location.search).get('reservationId');

    const acceptTerms = async () => {
      if (!reservationId) {
        alert('No se encontró ID de reservación.');
        return;
      }

      try {
        const reservationRef = doc(db, 'reservations', reservationId);
        await updateDoc(reservationRef, { acceptedTerms: true });
        alert('Términos aceptados con éxito.');
      } catch (error) {
        console.error('Error al aceptar los términos:', error);
        alert('Ocurrió un error al aceptar los términos.');
      }
    };

    return {
      accepted,
      acceptTerms
    };
  }
};
</script>

<style scoped>
.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
}

.terms {
  margin-bottom: 20px;
}

label {
  display: block;
  margin-top: 10px;
}

input, button {
  width: 100%;
  padding: 8px;
  margin-top: 5px;
}

button {
  margin-top: 20px;
  background-color: #007BFF;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}

button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}
</style>
